module.exports = __webpack_public_path__ + "img/b03.7245bae3.png";